<template>
  <div class="d-flex flex-column pa-4 gap-4">
    <span :class="compact ? 'font-size-14 font-weight-medium text-muted' : 'font-size-22'">{{ title }}</span>

    <side-result-compact v-if="compact" :metrics="metrics" :currentSections="currentSections" />
    <side-result-full v-else :metrics="metrics" :currentSections="currentSections" :direction="direction" />

    <div class="d-flex flex-column gap-2 mt-1" v-if="showButtons">
      <v-btn
        :id="modalId"
        class="new-btn"
        color="primary"
        depressed
        :disabled="!valid"
        @click="$emit('attach-attendance')"
      >
        Vincular atendimento
      </v-btn>
      <v-btn class="new-btn" text color="primary" @click="$emit('clean')"> Limpar calculadora </v-btn>
    </div>
  </div>
</template>

<script>
import { PropOptions } from 'vue'
import { Computed } from '@/_typedefs'
import SideResultFull from './SideResultFull.vue'
import SideResultCompact from './SideResultCompact.vue'

/**
 * @typedef {object} MetricSection
 * @property {number} limit
 * @property {string} name
 * @property {string} color
 */

/**
 * @typedef {object} Metric
 * @property {string} name
 * @property {number} min
 * @property {number} max
 * @property {number} value
 * @property {MetricSection[]} sections
 */

export default {
  components: { SideResultFull, SideResultCompact },
  props: {
    /** @type {PropOptions<Metric[]>} */
    metrics: {
      type: Array,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Resultado',
    },
    direction: {
      type: String,
      default: 'column',
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
    valid: {
      type: Boolean,
      default: false,
    },
    modalId: {
      type: String,
      default: 'noOboarding',
    },
  },
  computed: {
    /** @type {Computed<Record<string, MetricSection>>} */
    currentSections() {
      return Object.fromEntries(
        this.metrics.map((metric) => [metric.name, metric.sections.find((section) => metric.value <= section.limit)]),
      )
    },
  },
}
</script>

<style scpoed>
.section-limiter {
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #e6e6e6;
  border-radius: 2px;
  width: 4px;
  height: 16px;
  top: 50%;
}

.section-limiter-label {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
}

.progress {
  height: 8px;
  width: 100%;
  background-color: #e6e6e6;
}
</style>
